export const TEMPLATE_TYPES = {
	REQUIREMENTS: "REQUIREMENTS",
	CRITERIA_DETECTION: "CRITERIA_DETECTION",
};
